var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDriver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "driver",
    transform: "translate(-510 -234)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 52,
    height: 52,
    rx: 12,
    transform: "translate(510 234)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "driver_icon",
    "data-name": "driver icon",
    transform: "translate(122 -104)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 36,
    height: 36,
    transform: "translate(396 346.5)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16137",
    "data-name": "Group 16137",
    transform: "translate(404.439 353.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27663",
    "data-name": "Path 27663",
    d: "M-1333.28,2444.832h-1.5v-.891l.066-4.4.054-.131a4.38,4.38,0,0,1,3.494-2.179,8.557,8.557,0,0,0,3.219-1.031c.257-.166.689-.5.689-.875h1.5c0,.948-.671,2.65-5.166,3.387a3.3,3.3,0,0,0-2.295,1.167l-.061,4.078Z",
    transform: "translate(1334.341 -2420.809)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27794",
    "data-name": "Path 27794",
    d: "M-1325.759,2444.832h-1.5v-.875l-.061-4.078a3.3,3.3,0,0,0-2.295-1.167c-4.495-.737-5.166-2.438-5.166-3.387h1.5c0,.375.432.709.689.875a8.557,8.557,0,0,0,3.219,1.031,4.38,4.38,0,0,1,3.494,2.179l.054.131.066,4.409Z",
    transform: "translate(1345.341 -2420.809)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27665",
    "data-name": "Path 27665",
    d: "M-1322.965,2441.673c-2.854,0-4.993-2.8-5.084-2.923l1.2-.9-.6.451.6-.452c.018.023,1.786,2.325,3.885,2.325h.068c1.171-.028,2.285-.8,3.309-2.3l1.238.848c-1.315,1.92-2.836,2.912-4.519,2.949Z",
    transform: "translate(1332.581 -2421.569)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27666",
    "data-name": "Path 27666",
    d: "M-1320.626,2424.534a.81.81,0,0,1-.716-.448l1.334-.686a.7.7,0,0,0-.7-.362.674.674,0,0,0-.571.44,4.926,4.926,0,0,0,.041-.952c0-.1,0-.225,0-.374,0-.477-.007-1.2-.016-1.7v-.029l0-.029a2.962,2.962,0,0,0-1.075-2.8l-.005,0a5.224,5.224,0,0,0-4.83-.686,3.42,3.42,0,0,0-2.313,2.613v.005c-.062.5-.022,2.134,0,2.72v.024l.006,1.712-1.5.005-.006-1.7c-.01-.278-.075-2.239.012-2.943a4.877,4.877,0,0,1,3.21-3.815l.031-.013a6.75,6.75,0,0,1,6.274.864,4.417,4.417,0,0,1,1.7,4.075c.009.506.013,1.215.016,1.688,0,.148,0,.275,0,.371.008.977.015,1.821-.7,2A.78.78,0,0,1-1320.626,2424.534Z",
    transform: "translate(1334.908 -2415.83)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_752",
    "data-name": "Line 752",
    d: "M4,.75H0V-.75H4Z",
    transform: "translate(2.469 21.826)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27662",
    "data-name": "Path 27662",
    d: "M-1323.025,2421.229a.748.748,0,0,1,.431.136l4.7,3.295a.75.75,0,0,1,.314.7,17.591,17.591,0,0,1-.948,3.772c-1.292,3.367-3.135,4.073-4.453,4.073h-.053c-4.4-.062-5.749-7.119-5.8-7.42a.75.75,0,0,1,.3-.743l5.077-3.673A.75.75,0,0,1-1323.025,2421.229Zm3.889,4.392-3.882-2.722-4.246,3.072a15.107,15.107,0,0,0,.953,2.771c.915,1.95,2.024,2.948,3.3,2.966h.032c1.536,0,2.508-1.692,3.052-3.111A16.161,16.161,0,0,0-1319.137,2425.621Z",
    transform: "translate(1332.747 -2417.4)",
    fill: "#19bc9c"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriver);
export default __webpack_public_path__ + "static/media/driver.e249fb6e604c4be2973d44dd8529dc0b.svg";
export { ForwardRef as ReactComponent };